import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Banner} from '@primer/react'

type Props = {
  propertyName: string
  resourceUsages?: string[]
  resourceTypeDisplayName?: Record<string, string>
}

export function DefinitionUsagesBanner({propertyName, resourceUsages, resourceTypeDisplayName}: Props) {
  const showResourceUsages = isFeatureEnabled('custom_property_usages_ui')

  // Only include usages that have a known display name — we don't want to surface resource class names to users
  const displayableUsageNames = resourceUsages?.flatMap(usage => resourceTypeDisplayName?.[usage] ?? []).join(', ')
  const hasUsages = showResourceUsages && displayableUsageNames

  const renderDescription = () => {
    if (!showResourceUsages) {
      return (
        <span>
          The <strong>{propertyName}</strong> property may be in use by other GitHub features. Please verify before
          deletion.
        </span>
      )
    }

    return (
      <>
        {hasUsages ? (
          <span>
            The <strong>{propertyName}</strong> property may be in use by the following GitHub features:{' '}
            <strong>{displayableUsageNames}</strong>.
          </span>
        ) : (
          <span>
            No other GitHub features found that use the property: <strong>{propertyName}</strong>.
          </span>
        )}
      </>
    )
  }

  return (
    <Banner
      title="Other definition usages"
      hideTitle
      variant={hasUsages || !showResourceUsages ? 'warning' : 'info'}
      data-testid="usages-banner"
      description={renderDescription()}
    />
  )
}
